import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "AirPlay.svg",
  "use": "AirPlay.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"AirPlay.svg\"><path d=\"M56.01,16.0208a4,4,0,0,0-4-4h-40a4,4,0,0,0-4,4v26a4,4,0,0,0,4,4h4a2,2,0,1,0,0-4h-3a1,1,0,0,1-1-1v-24a1,1,0,0,1,1-1h38a1,1,0,0,1,1,1v24a1,1,0,0,1-1,1h-3a2,2,0,1,0,0,4h4a4,4,0,0,0,4-4ZM44.014,54.0363a2.0067,2.0067,0,0,0,1.4143-3.4244L33.4276,38.576a1.996,1.996,0,0,0-2.8285,0L18.5985,50.6119a2.0067,2.0067,0,0,0,1.4141,3.4244Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol